module.exports = "\r\n<router-outlet></router-outlet>\r\n\r\n"